import React, {lazy} from 'react';
import ReactDOM from 'react-dom';
import './i18n.js';
import LoadingApp from './LoadingApp';

const App = lazy(() => import('./App.js'));

const AppWithFallback = () => (
    <React.Suspense fallback={<LoadingApp />}>
        <App />
    </React.Suspense>
);

ReactDOM.render(<AppWithFallback />, document.getElementById('root'));
